export default __webpack_public_path__ + "static/media/ttac1.603902b3.svg";